import api from './api.service';

export interface UnifiedDashboardData {
  overview: {
    totalApplications: number;
    totalHosts: number;
    totalClusters: number;
    activeIncidents: number;
    criticalAlerts: number;
    activeAlerts: number;
    activeAnomalies: number;
    tracesToday: number;
    logsToday: number;
    avgResponseTime: number;
    errorRate: number;
  };
  health: {
    apmStatus: 'healthy' | 'degraded' | 'down';
    infrastructureStatus: 'healthy' | 'degraded' | 'down';
    kubernetesStatus: 'healthy' | 'degraded' | 'down';
    cloudStatus: 'healthy' | 'degraded' | 'down';
  };
  insights: {
    recentIncidents: any[];
    topAnomalies: any[];
    costForecasts: any[];
  };
  alerts: {
    critical: number;
    high: number;
    medium: number;
    low: number;
    recent: any[];
  };
  cloudSummary: {
    lastScanDate?: string;
    totalSecurityFindings: number;
    totalCostSavings: number;
    criticalFindings: number;
  };
  performance: {
    data: Array<{
      time: string;
      responseTime: number;
      requests: number;
    }>;
  };
  errorRate: {
    data: Array<{
      name: string;
      value: number;
    }>;
  };
  serviceHealth: Array<{
    id: string;
    name: string;
    status: number;
    incidents: number;
  }>;
  recentActivity: Array<{
    type: string;
    message: string;
    service: string;
    time: string;
    severity: string;
  }>;
  rum: {
    totalSessions: number;
    activeSessions: number;
    frontendErrors: number;
    affectedUsers: number;
    webVitals: {
      lcp: number;
      fid: number;
      cls: number;
    };
  };
}

export const observabilityApi = {
  getDashboard: async (timeRange = '24h', applicationId?: string): Promise<UnifiedDashboardData> => {
    const params = new URLSearchParams();
    params.append('timeRange', timeRange);
    if (applicationId) {
      params.append('applicationId', applicationId);
    }
    const response: any = await api.get(`/v1/observability/dashboard?${params.toString()}`);
    return response.data;
  },
};
